import { useMutation } from "@apollo/client"
import { STORE_REGISTER } from "../queries/storeRegister"
import { useToast } from "@/hooks/use-toast"

interface StoreRegisterInput {
  name: string
  inChargePerson: string
  description?: string
  logo?: string
  cover?: string
  phone: string
  email: string
  siteUrl?: string
  facebookUrl?: string
  instagramUrl?: string
  youtubeUrl?: string
  twitterUrl?: string
  address: {
    name: string
    address: string
    countryId: number
    regionId: number
    locationId: number
  }
}

export const useStoreRegister = () => {
  const { toast } = useToast()

  const [storeRegisterMutation, { loading, error }] = useMutation(STORE_REGISTER, {
    onCompleted: (data) => {
      if (data.StoreRegister.status.success) {
        toast({
          title: "Tienda creada",
          variant: "success",
          description:
            "La tienda ha sido creada exitosamente, ahora espera que el equipo de JO@KLU.cl valide tu tienda.",
        })
      } else {
        toast({
          title: "Error",
          description: data.StoreRegister.status.detail,
          variant: "destructive",
        })
      }
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      })
    },
  })

  const registerStore = async (input: StoreRegisterInput) => {
    try {
      const result = await storeRegisterMutation({
        variables: { input },
      })
      return result?.data
    } catch (error) {
      console.error("Store registration error:", error)
      throw error
    }
  }

  return {
    registerStore,
    loading,
    error,
  }
}
